module.exports = __webpack_public_path__ + "img/wo.4178aeed.png";